import * as React from "react";

interface PreviewCloseButtonProps {
  onClose: () => void;
}

class PreviewCloseButton extends React.Component<PreviewCloseButtonProps, {}> {
  public render() {
    return (
      <a className="velaro-preview-message-close" onClick={this.props.onClose}>
        <svg height="26" width="26" viewBox="0 0 100 100">
          <line
            strokeLinecap="round"
            x1="35"
            y1="35"
            x2="65"
            y2="65"
            stroke="#d3d3d3"
            strokeWidth="8"
          />
          <line
            strokeLinecap="round"
            x1="35"
            y1="65"
            x2="65"
            y2="35"
            stroke="#d3d3d3"
            strokeWidth="8"
          />
        </svg>
      </a>
    );
  }
}

export default PreviewCloseButton;
